import { FulfillmentGroupReassignmentReasonSchema } from "@redotech/redo-fulfillment-group-common/reassignment-reason";
import * as z from "zod";

export const assignFulfillmentGroupToMerchant = {
  name: "assignFulfillmentGroupToMerchant" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    reason: FulfillmentGroupReassignmentReasonSchema,
    note: z.string().max(500).nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    needsMerchantLocation: z.boolean(),
  }),
};
